export const IMPERSONATING_USERNAME_COOKIE = 'sendgrid-impersonating-username';
export const TWILIO_SENDGRID_LOGO =
  'https://uiux.s3.amazonaws.com/logo/sg-twilio-lockup.svg';
export const LOGO_ALT = 'Twilio SendGrid Logo';
